"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_number_settings_component_1 = require("./sis-number-settings.component");
var services_1 = require("../../../services");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var SisNumberComponent = /** @class */ (function (_super) {
    __extends(SisNumberComponent, _super);
    function SisNumberComponent(formattingService) {
        var _this = _super.call(this) || this;
        _this.formattingService = formattingService;
        _this.valueChange = new core_1.EventEmitter();
        _this.formattedValue = '';
        _this._isReadonly = false;
        _this._min = Number.NEGATIVE_INFINITY;
        _this._max = Number.POSITIVE_INFINITY;
        _this.destroySubject$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(SisNumberComponent.prototype, "isReadonly", {
        get: function () {
            return this._isReadonly;
        },
        set: function (value) {
            this._isReadonly = value;
            this.formatValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberComponent.prototype, "min_num", {
        get: function () {
            return this._min;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberComponent.prototype, "max_num", {
        get: function () {
            return this._max;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberComponent.prototype, "step_num", {
        get: function () {
            return this._step;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberComponent.prototype, "min", {
        set: function (min) {
            if (min) {
                this._min = +min;
            }
            else {
                this._min = Number.NEGATIVE_INFINITY;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberComponent.prototype, "max", {
        set: function (max) {
            if (max) {
                this._max = +max;
            }
            else {
                this._max = Number.POSITIVE_INFINITY;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberComponent.prototype, "step", {
        set: function (step) {
            if (step) {
                this._step = +step;
            }
            else {
                this._step = 1;
            }
        },
        enumerable: true,
        configurable: true
    });
    SisNumberComponent.prototype.formatAndEmitValue = function () {
        this.formatValue();
        this.valueChange.emit(this.value);
    };
    SisNumberComponent.prototype.blur = function () {
        if (this.value !== undefined && this.value !== null) {
            this.value = Math.min(Math.max(this.value, this._min), this._max);
            this.formatAndEmitValue();
        }
    };
    SisNumberComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    SisNumberComponent.prototype.ngOnInit = function () {
        this.formatAndEmitValue();
    };
    SisNumberComponent.prototype.hasValue = function () {
        return this.value !== null && this.value !== undefined;
    };
    SisNumberComponent.prototype.onKeyPress = function (evt) {
        if (this.value && this.value.toString().length > this.maxLength - 1) {
            evt.preventDefault();
        }
    };
    SisNumberComponent.prototype.formatValue = function () {
        var _this = this;
        if (!this.fieldName || !this._isReadonly) {
            return;
        }
        if (!this.value && this.value !== 0) {
            this.formattedValue = '';
        }
        else {
            this.formattingService
                .formatNumber(this.value)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (value) { return (_this.formattedValue = value); }, function (err) {
                console.error(err);
                _this.formattedValue = '';
            });
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNumberComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisNumberComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisNumberComponent.prototype, "maxLength", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNumberComponent.prototype, "fieldName", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisNumberComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisNumberComponent.prototype, "isReadonly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisNumberComponent.prototype, "min", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisNumberComponent.prototype, "max", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisNumberComponent.prototype, "step", null);
    SisNumberComponent = __decorate([
        core_1.Component({
            selector: 'sis-number',
            template: "\n        <ng-container *ngIf=\"!isReadonly\">\n            <mat-form-field\n                class=\"sis-form-field\"\n                color=\"accent\"\n                [floatLabel]=\"'never'\"\n                [hintLabel]=\"hint | sisTranslateMultilingual | async\"\n            >\n                <input\n                    matInput\n                    [(ngModel)]=\"value\"\n                    class=\"sis-numeric-input\"\n                    [id]=\"id\"\n                    type=\"number\"\n                    [step]=\"step_num\"\n                    (blur)=\"blur()\"\n                    (ngModelChange)=\"formatAndEmitValue()\"\n                    [max]=\"max_num\"\n                    [min]=\"min_num\"\n                    (keypress)=\"onKeyPress($event)\"\n                />\n            </mat-form-field>\n        </ng-container>\n        <div *ngIf=\"isReadonly\" id=\"{{ id }}\">\n            <ng-container *ngIf=\"hasValue()\">\n                <div class=\"sis-numeric-text\">{{ formattedValue }}</div>\n            </ng-container>\n            <span *ngIf=\"!hasValue()\" class=\"sis-no-data\">\n                {{ 'de_no_data' | sisTranslate | async }}\n            </span>\n        </div>\n    ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 2,
            name: 'Number',
            nameKey: 'de.controls.number.title',
            settings: {
                main: sis_number_settings_component_1.SisNumberSettingsComponent,
            },
            template: "\n        <sis-number\n                [id]=\"'%{id}'\"\n                [value]=\"%{checkedItem}\"\n                [fieldName]=\"%{checkedItem-name}\"\n                (valueChange)=\"contextEntity.getProperty('%{checkedItem-name}').value = $event\"\n                [isReadonly]=\"%{isReadonly}\"\n                [hint]=\"%{hint}\"\n                [step]=\"%{step}\"\n                [max]=\"%{max}\"\n                [min]=\"%{min}\"\n                %{#maxLength} [maxLength]=\"%{maxLength}\" %{/maxLength}>\n        </sis-number>\n    ",
        }),
        __metadata("design:paramtypes", [services_1.FormattingService])
    ], SisNumberComponent);
    return SisNumberComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisNumberComponent = SisNumberComponent;
//# sourceMappingURL=sis-number.component.js.map